export const AUTH_TYPES = {
    BASIC_AUTH: 'BASIC_AUTH',
    BEARER_AUTH: 'BEARER_AUTH',
    OAUTH_2_0: 'OAUTH_2_0',
};
